<template>
    <div class="detail-map">

    </div>
</template>

<script>
    /* global google */

    export default {
        name: 'DetailMap',
        props: ['resource'],
        data (){
            return {
                geocoder: null,
                map: null,
                infoWindow: null
            }
        },
        mounted (){
            this.geocoder = new google.maps.Geocoder();
            this.map = new google.maps.Map(this.$el);
            this.infoWindow = new google.maps.InfoWindow();

            this.map.setOptions({styles: [
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [{"visibility": "off"}]
                    }
                ]
            });

            /*
            this.map.data.loadGeoJson('https://transit.land/api/v1/stops.geojson?served_by=o-9pr8n-eurekatransitservice&per_page=false');
            this.map.data.loadGeoJson('https://transit.land/api/v1/stops.geojson?served_by=o-9pp-redwoodtransitsystem&per_page=false');
            this.map.data.setStyle(function(feature){
               return {
                   icon: {
                       url: "http://maps.google.com/mapfiles/kml/shapes/bus.png",
                       scaledSize: {width: 15, height: 15}
                   }
               };
            });

            this.map.data.addListener('click', function(event){
                console.log(event.feature.getProperty("routes_serving_stop"))
                //this.map.data.overrideStyle(event.feature, {zIndex: 10})
            });

             */
            let transitLayer = new google.maps.TransitLayer();
            transitLayer.setMap(this.map);

        },
        watch: {
            resource: {
                handler (){
                    this.geocoder.geocode({ address: this.resource.address + " " + this.resource.city + ", " + this.resource.state + " " + this.resource.zip}, (results, status) => {
                        if (status !== 'OK' || !results[0]) {
                            throw new Error(status);
                        }

                        this.map.setCenter(results[0].geometry.location);
                        this.map.fitBounds(results[0].geometry.viewport);
                        this.map.setZoom(16);


                        const marker = new google.maps.Marker({position: results[0].geometry.location, map: this.map});
                        google.maps.event.addListener(marker, 'click', this.markerClick(marker, this.infoWindow, this.map));
                        google.maps.event.trigger(marker, 'click');
                    });
                }
            }
        },
        methods: {
            markerClick(marker, infoWindow, map){
                let html = "<strong>" + this.resource.name + "</strong>";
                html += "<br />";
                html += "<span>" + this.resource.address + "</span>";
                html += "<br />";
                html += "<span>" + this.resource.city + ", " + this.resource.state + " " + this.resource.zip + "</span>";

                return function(){
                    infoWindow.setContent(html);
                    infoWindow.open(map, marker)
                }
            }
        }
    };
</script>

<style scoped>
    .detail-map {
        min-height: 300px;
        height: 100%;
    }
</style>